import { ShareMeta, ShareMetaOptions, shareMetaForPath } from 'shared/lib/share-meta';

/** Ensure a meta tag exists and set its content (creates the tag if missing). */
export const upsertMetaTag = (attr: 'name' | 'property', key: string, content: string): void => {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

/** Apply share meta to the live document (browser tab + in-app WebViews). */
export const applyShareMetaToDocument = (meta: ShareMeta, pageUrl?: string): void => {
  document.title = meta.title;
  upsertMetaTag('name', 'description', meta.description);
  upsertMetaTag('property', 'og:title', meta.title);
  upsertMetaTag('property', 'og:description', meta.description);
  upsertMetaTag('property', 'og:type', 'website');
  if (pageUrl) {
    upsertMetaTag('property', 'og:url', pageUrl);
  }
  upsertMetaTag('name', 'twitter:card', 'summary');
  upsertMetaTag('name', 'twitter:title', meta.title);
  upsertMetaTag('name', 'twitter:description', meta.description);
};

export { shareMetaForPath };
export type { ShareMeta, ShareMetaOptions };
